export const unique = <T>(src: T[]): T[] =>
  src.reduce<T[]>((result, item) => {
    if (!result.includes(item)) {
      result.push(item)
    }
    return result
  }, [])
